import capitalizeFirst from '@zola-helpers/client/dist/es/transformers/capitalizeFirst';
import { AllFilters, FILTER_TEMPLATE_VARIABLES } from '../filters';
import type { RequiredSEOData } from '../types';
import { PlpCardType } from '../constants';
import { REQUIRED_DATA_BY_CARD_TYPE, TemplateProps } from './dataByCardType';

// This should theoretically never be used, but leaving it just in case.
const DEFAULT_PLP_META: RequiredSEOData = {
  canonical: `https://www.zola.com/wedding-planning/invitations/shop`,
  title: 'Wedding Invitations & Save the Dates - Zola',
  description:
    'Looking for beautiful paper save-the-date cards & wedding invitations? Create a perfect, affordable design for your wedding & order in minutes!',
  keywords: 'wedding invitations, wedding invitation cards, save the dates, save the date cards',
  h1: 'Wedding Invitations & Save the Dates',
  h2: 'All about Zola wedding invitations & save the dates',
  faqHeading: 'Frequently asked questions',
};

export const getRequiredSEO = (
  typeKey: PlpCardType | undefined,
  filterKey: AllFilters | undefined
): RequiredSEOData => {
  if (!typeKey) return DEFAULT_PLP_META;

  const { unfiltered, templates } = REQUIRED_DATA_BY_CARD_TYPE[typeKey];

  // SEO data for this card type is missing - return global default.
  if (!unfiltered) return DEFAULT_PLP_META;

  // Page is unfiltered, or filter copy templates are missing - return this card type's unfiltered default.
  if (!filterKey || !templates) return unfiltered;

  // Fill out the template using the main filter's variables
  const { label, keywords, urlSuffix } = FILTER_TEMPLATE_VARIABLES[filterKey];
  const templateProps: TemplateProps = {
    filterKey,
    urlSuffix,
    labelTitleCase: label,
    labelLowerCase: label.toLowerCase(),
    labelCapitalized: capitalizeFirst(label, 1),
    keywordPrefixes: keywords,
  };

  const getValue = (key: keyof RequiredSEOData) => templates[key](templateProps) || unfiltered[key];

  return {
    title: getValue('title'),
    description: getValue('description'),
    canonical: getValue('canonical'),
    keywords: getValue('keywords'),
    h1: getValue('h1'),
    h2: getValue('h2'),
    faqHeading: getValue('faqHeading'),
  };
};
